import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import React from 'react';
import {
  FluentProvider,
  webLightTheme,
  DataGrid,
  DataGridHeader,
  DataGridRow,
  DataGridHeaderCell,
  DataGridBody,
  DataGridCell,
} from '@fluentui/react-components';
import { Action, Role } from '../../utils/statApi/RolesApi';
import Card from '../common/card/Card';
import SpanWithLabel from '../common/SpanWithLabel';
import StackColumn from '../common/StackColumn';
import getColumns from './ActionList.config';

interface IActionDetail {
  action: Action;
}
const ActionDetail = ({ action }: IActionDetail): JSX.Element => {
  const columns = getColumns();

  return (
    <>
      {action && (
        <>
          <Card title={action?.displayName}>
            <Stack horizontal wrap horizontalAlign="space-around" tokens={{ childrenGap: 60 }}>
              <StackColumn>
                <SpanWithLabel labelText="Description" value={action?.description} />
              </StackColumn>
              <StackColumn>
                <SpanWithLabel labelText="Category" value={action?.category} />
              </StackColumn>
            </Stack>
          </Card>
          <br />
          <Card title="Roles">
            <FluentProvider theme={webLightTheme}>
              <DataGrid
                items={action?.roles || []}
                columns={columns}
                resizableColumns
                aria-label="Roles for this action"
                getRowId={(item) => item.id}
              >
                <DataGridHeader>
                  <DataGridRow>
                    {({ renderHeaderCell }) => (
                      <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                    )}
                  </DataGridRow>
                </DataGridHeader>
                <DataGridBody<Role>>
                  {({ item, rowId }) => (
                    <DataGridRow<Role> key={rowId}>
                      {({ renderCell }) => <DataGridCell>{renderCell(item)}</DataGridCell>}
                    </DataGridRow>
                  )}
                </DataGridBody>
              </DataGrid>
            </FluentProvider>
          </Card>
        </>
      )}
    </>
  );
};

export default ActionDetail;
